<template>
  <div class="shagquanDetailPage">
       <XR-head titleText="商品详情" :rightShow="false" ref="headObj"></XR-head>
       <mu-list>
          <mu-list-item class="address">
            <p >订单配送至 <span>公司</span> </p>
             <router-link to="/usercenter/address?redirecturl=/usercenter/address">
                <div class="dizhi">
                   龙潭大厦龙潭大厦17楼<i class="fa fa-angle-right"></i>
                </div>
             </router-link>
             <div class="contact"> <span class="name">张三</span><span class="phone">18272173481</span> </div>
         </mu-list-item>
       </mu-list>
       <mu-list>
         <mu-list-item class="date">
              <p class="title">送达时间</p>
              <div class="zhunshi">准时达服务：当前暂不享受超时赔付?</div>
              <mu-icon slot="right" value=":fa fa-angle-right"/>
         </mu-list-item>
         <mu-list-item class="pay">
              <div class="cont">
                <p class="fs">支付方式</p>
                <p class="zhifubao">支付宝</p>
              </div>
              <mu-icon slot="right" value=":fa fa-angle-right"/>
         </mu-list-item>
       </mu-list>  
       <mu-list>
          <mu-list-item class="storename" title="菜大师(徐东店)">

          </mu-list-item>
          <mu-list-item class="cainame">
              <div class="caimg">
                  <img :style="{height: iHeight+'px'}" ref="imgH" src=" ../static/shangquan/1.png" alt="">
                 <div class="name">
                    <p>绿豆汤</p>
                    <p class="shuoming">不送米饭</p> 
                 </div>
                  <span class="shuliang">x2</span>
                  <span class="price">￥14.0</span>
              </div>
          </mu-list-item>
          <mu-list-item class="cainame">
              <div class="caimg">
                  <img :style="{height: iHeight+'px'}" ref="imgH" src=" ../static/shangquan/1.png" alt="">
                 <div class="name">
                    <p>绿豆汤</p>
                 </div>
                  <span class="shuliang">x2</span>
                  <span class="price">￥14.0</span>
              </div>
          </mu-list-item>
          <mu-list-item class="qita">
             <div class="lunchBox">
                <div class="box">包装费</div>
                <div class="nam">餐盒</div>
                <div class="xian">￥3</div>
             </div>
          </mu-list-item>
          <mu-list-item class="fei">
             <div class="lunchBox">
                <div class="box">费送费</div>
                <div class="nam">蜂鸟专送</div>
                <div class="jiu">￥4.1</div>
                <div class="xian">￥3</div>
             </div>
          </mu-list-item>
          <mu-list-item class="qita">
             <div class="lunchBox">
                <div class="box">满减</div>
                <div class="nam">在线支付立减优惠</div>
                <div class="jian">-￥3</div>
             </div>
          </mu-list-item>
          <mu-list-item class="hongbao">
              <div class="cont">
                <p class="fs">红包</p>
                <p class="zhifubao" >无可用红包</p>
              </div>
              <mu-icon slot="right" value=":fa fa-angle-right"/>
         </mu-list-item>
      </mu-list>
  </div>
</template>
<script>
export default {
  data(){
    return{
      fullWidth:document.documentElement.clientWidth
    }
  },
  mounted:function(){
    this.iHeight = this.$refs.imgH.offsetWidth
  },
  mothods:{

  }
}
</script>


<style>
  .shagquanDetailPage{
    background: #eee;
  }
  .shagquanDetailPage .mu-list{
    background: #fff;
  }
  .shagquanDetailPage .mu-list:not(:first-child){
    margin-top: 10px;
  }
  .shagquanDetailPage .mu-list .address p{
    font-size: 12px
  }
  .shagquanDetailPage .mu-list .address p span{
    border: 1px solid #666;
    font-size: 12px;
    height: 25px;
    line-height: 25px;
  }
  .shagquanDetailPage .mu-list .address .dizhi{
    font-size: 14px;
    font-weight: bold;
    color: #000;
  }
   .shagquanDetailPage .mu-list .address .fa-angle-right{
     float: right;
   }
   .shagquanDetailPage .mu-list .address .contact{
     font-size: 12px;
     height: 25px;
     line-height: 25px;
   }
   .shagquanDetailPage .mu-list .date .mu-item{
     border-bottom: 1px #f5f5f5 solid;
    }
   .shagquanDetailPage .mu-list .date .title{
     font-weight: bold;
     font-size: 14px;
     color: #000;
   }
   .shagquanDetailPage .mu-list .date .zhunshi{
     font-size: 12px;
     color: #999;
   }
   .shagquanDetailPage .mu-list .date .mu-item-right .fa-angle-right,.shagquanDetailPage .mu-list .pay .mu-item-right .fa-angle-right{
     font-size: 14px;
    text-align: right;
    color: #000;
   }
   .shagquanDetailPage .mu-list .pay {

   }
   .shagquanDetailPage .mu-list .pay  .cont{
     display: flex;
   }
   .shagquanDetailPage .mu-list .pay  .cont .fs{
     width: 70%;
     font-size: 14px;
     font-weight: bold;
     color: #000;
   }
   .shagquanDetailPage .mu-list .pay  .cont .zhifubao{
     width: 30%;
     font-size: 14px;
     text-align: right;
   }
   .shagquanDetailPage .mu-list .hongbao  .cont{
     display: flex;
   }
   .shagquanDetailPage .mu-list .hongbao  .cont .fs{
     width: 70%;
     font-size: 14px;
     font-weight: bold;
     color: #000;
   }
   .shagquanDetailPage .mu-list .hongbao  .cont .zhifubao{
     width: 30%;
     font-size: 12px;
     color: #999;
     text-align: right;
   }
   .shagquanDetailPage .mu-list .hongbao  .mu-item-right .fa-angle-right{
     font-size: 12px;
     color: #000;
     text-align: right;
   }
   .shagquanDetailPage .mu-list .storename{
     border-bottom: 1px solid #f5f5f5;
   }
   .shagquanDetailPage .mu-list .storename .mu-item-title{
     font-size: 14px;
     font-weight: bold;
     color: #000;
   }
   .shagquanDetailPage .mu-list  .cainame{
    
   }
   .shagquanDetailPage .mu-list  .cainame .caimg{
     width: 100%;
     display: flex;
     align-items: center;
   }
   .shagquanDetailPage .mu-list  .cainame .caimg .name{
     margin-left: 10%;
     width: 55%;
   }
   .shagquanDetailPage .mu-list  .cainame .caimg .name .shuoming{
     font-size: 12px;
     color: #999;
   }
   .shagquanDetailPage .mu-list  .cainame .caimg img{
    width: 10%;
   }
   .shagquanDetailPage .mu-list  .cainame .caimg .shuliang{
     width: 10%;
     text-align: center;
   }
   .shagquanDetailPage .mu-list  .cainame .caimg .price{
     width: 15%;
     text-align: right
   }
   .shagquanDetailPage .mu-list .fei .lunchBox{
     display: flex;
   }
    .shagquanDetailPage .mu-list .fei .lunchBox .box{
      font-size: 12px;
      width: 15%;
      text-align: center;
      line-height: 20px;
      background: #c3d9ff;
      color: #4a5a75;
    }
    .shagquanDetailPage .mu-list .fei .lunchBox .nam{
      margin-left: 5%;
      width: 55%;
    }
    .shagquanDetailPage .mu-list .fei .lunchBox .jiu{
      text-decoration: line-through;
      color: #999;
      width: 10%;
    }
    .shagquanDetailPage .mu-list .fei .lunchBox .xian{
      width: 15%;
      text-align: right;
    }
    .shagquanDetailPage .mu-list .qita .lunchBox{
     display: flex;
   }
    .shagquanDetailPage .mu-list .qita .lunchBox .box{
      font-size: 12px;
      width: 15%;
      text-align: center;
      line-height: 20px;
      background: #c3d9ff;
      color: #4a5a75;
    }
    .shagquanDetailPage .mu-list .qita .lunchBox .nam{
      margin-left: 5%;
      width: 55%;
    }
    .shagquanDetailPage .mu-list .qita .lunchBox .xian{
      width: 25%;
      text-align: right;
    }
    .shagquanDetailPage .mu-list .qita .lunchBox .jian{
      color: red;
      width: 25%;
      text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/pages/shangquan/shangquandetail.vue